import React, { memo, useState } from "react";
import {
	Badge,
	Card,
	CardBody,
	CardHeader,
	Col,
	Collapse,
	Label,
	Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import EmailDomainMismatchAlert from "./EmailDomainMismatchAlert";

const RequesterDetails = ({ t, report }) => {
	const [isOpen, setIsOpen] = useState(true);
	const isPrivatePerson = report?.requester_type === "private_person";
	const organizationWebsite = report?.organization_website;

	const fields = [
		{
			key: "requester_type",
			label: t("Submitting as"),
			value: (
				<Badge
					color={"info"}
					className="bg-info font-size-12"
				>
					{isPrivatePerson ? t("Private person") : t("Company")}
				</Badge>
			),
		},
		...(!isPrivatePerson
			? [
					{
						key: "organization_name",
						label: t("Organization"),
						value: report?.organization_name || "-",
					},
					{
						key: "organization_website",
						label: t("Website"),
						value: organizationWebsite ? (
							<a
								href={organizationWebsite}
								target="_blank"
								rel="noopener noreferrer"
							>
								{organizationWebsite}
							</a>
						) : (
							"-"
						),
					},
			  ]
			: []),
	];

	return (
		<Row>
			<Col sm="12">
				<Card className="mb-1 shadow-none">
					<Link
						to="#"
						onClick={(e) => {
							e.preventDefault();
							setIsOpen(!isOpen);
						}}
						style={{ cursor: "pointer" }}
						className="text-dark"
					>
						<CardHeader className="org-primary-header">
							<h6 className="m-0 font-14">
								{t("Requester")}
								<i
									className={`float-end accor-plus-icon mdi ${
										isOpen ? "mdi-minus" : "mdi-plus"
									}`}
								></i>
							</h6>
						</CardHeader>
					</Link>

					<Collapse isOpen={isOpen}>
						<CardBody style={{ paddingLeft: "2px" }}>
							{fields.map((field) => (
								<Row key={field.key}>
									<Col sm="12">
										<div className="mb-3">
											<Label className="form-check-label mb-1">
												{field.label}
											</Label>
											<div className="text-answers" style={{ margin: 0 }}>
												{field.value}
											</div>
										</div>
									</Col>
								</Row>
							))}

							<EmailDomainMismatchAlert report={report} compact />
						</CardBody>
					</Collapse>
				</Card>
			</Col>
		</Row>
	);
};

export default withNamespaces()(memo(RequesterDetails));
